/**
 * The view of the course checks, as the address holds it. It opens on the
 * signal: the courses a client says were not finished when their specialist
 * ended them.
 */
import { pageOf } from "@/shared/lib/search";

/**
 * Which answers are listed. hg-order narrows by the answer given (`finished`)
 * or lists everything, the unanswered too: there is no list of the
 * unanswered alone.
 */
export const CHECK_ANSWERS = ["not_finished", "finished", "all"] as const;
export type CheckAnswer = (typeof CHECK_ANSWERS)[number];
export const DEFAULT_CHECK_ANSWER: CheckAnswer = "not_finished";

export interface CourseChecksSearch {
  answer?: CheckAnswer;
  page?: number;
}

export function parseCourseChecksSearch(
  raw: Readonly<Record<string, unknown>>,
): CourseChecksSearch {
  const search: CourseChecksSearch = {};
  const answer = CHECK_ANSWERS.find((known) => known === raw["answer"]);
  if (answer !== undefined && answer !== DEFAULT_CHECK_ANSWER) search.answer = answer;
  const page = pageOf(raw["page"]);
  if (page !== undefined) search.page = page;
  return search;
}

/** What `GET /v2/admin/course-checks` is asked: `finished` left out lists everything. */
export function courseChecksFilter(search: CourseChecksSearch): { finished?: boolean } {
  const answer = search.answer ?? DEFAULT_CHECK_ANSWER;
  return answer === "all" ? {} : { finished: answer === "finished" };
}
